<template>
  <div class="footer">
    <div class="footer__body">
      <p class="mb-m">
        По&nbsp;всем вопросам обращайтесь по&nbsp;адресу:&nbsp;<a
          href="mailto:talent@kruzhok.org"
          class="link"
          >talent@kruzhok.org</a
        >
      </p>
      <a
        :href="termsOfUseLink"
        target="_blank"
        rel="noopener noreferrer"
        class="footer__link link"
        >Пользовательское&nbsp;соглашение</a
      >
      <a
        :href="policyLink"
        target="_blank"
        rel="noopener noreferrer"
        class="link"
        >Политика&nbsp;конфиденциальности</a
      >
      <div class="footer__socials mt-m">
        <div class="footer__social-icons">
          <a
            href="https://vk.com/kruzhok_nti"
            target="_blank"
            rel="noopener noreferrer"
            class="footer__social mr-m"
            title="Вконтакте"
            ><BaseIcon glyph="vk" width="18px"
          /></a>
          <a
            href="https://t.me/joinchat/EOwr2FF-Bcxhp3r6OOK-Cw"
            target="_blank"
            rel="noopener noreferrer"
            class="footer__social"
            title="Telegram"
            ><BaseIcon width="18px" glyph="telegram"
          /></a>
        </div>

        <img
          src="@/assets/images/kd-logo.svg"
          alt="Логотип кружкового движения"
          class="footer__logo"
        />
        <div class="footer__contest">
          &copy;&nbsp;Кружковое движение {{ year }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
  computed: {
    year() {
      return new Date().getFullYear();
    },
    termsOfUseLink() {
      return process.env.VUE_APP_TALENT_HOST + "/terms_of_use";
    },
    policyLink() {
      return process.env.VUE_APP_TALENT_HOST + "/policy";
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  padding: 40px 0;
  background-color: @base-color;
  font-size: @font-size-s;
  line-height: @line-height-s;
  color: @gray-color;
  &__body {
    max-width: 960px;
    margin: 0 auto;
    padding: 0 10px;
  }

  &__link {
    margin-right: @margin-xxl;
  }
  &__socials {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__social {
    width: 32px;
    height: 32px;
    color: @dark-gray-color;
    transition: color 0.3s;
    cursor: pointer;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 32px;
      height: 32px;
    }

    &:hover {
      color: @link-color;
    }
  }
  @media (max-width: @screen-xs + 100px) {
    &__link {
      display: flex;
      &:first-of-type {
        margin-bottom: @margin-m;
      }
    }
  }
  @media (max-width: @screen-xs) {
    &__socials {
      flex-direction: column;
      align-items: flex-start;
    }
    &__logo {
      order: 2;
      margin-bottom: @margin-m;
    }
    &__social-icons {
      order: 3;
    }
    &__contest {
      order: 1;
      margin-bottom: @margin-m;
    }
  }
}
</style>
